import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ForbiddenComponent } from './forbidden.component';

const routes: Routes = [
  { path: 'forbidden', component: ForbiddenComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    errorHandler: error => {
      window.location.href = '/forbidden';
    }
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
